<template>
  <div>
    <template v-if="showSurveyModalProp">
      <survey-modal :show-modal="((showSurveyModal && (!isSurveyModalInteracted)) || (showSurveyModalXS && !isSurveyModalInteractedXS)) && (selectedLicenses.length !== 0)" :productName="selectedLicenses" :close-action="closeSurveyModal" />
    </template>
    <b-modal :visible="modal" @hide="resetModalAndClose" v-b-modal="modalName" >
    <template v-if="errorType === ''">
      <div slot="modal-title">
        {{ allocateTitle }}
        <div v-if="isFull && currentStep === 1" class="full-allocation-message">
          {{ $t('fullAllocationMessage') }}
        </div>
      </div>
    </template>
    <template v-else>
      <div slot="modal-title" class="danger-text">
        {{ allocateTitle }}
      </div>
    </template>
    <b-container fluid v-if="currentStep === 1">
      <b-row class="inputs-row">
        <div class="col-4">
          <b-input
            class="modal-input"
            @input.native="handleAllocateCountBlur"
            v-model="remainingCount"
            :state="remainingCountState"
            :disabled="isFull"
            tabindex="1"
          /> of {{ totalRemainingCount }}
        </div>
        <div class="col-8">
          <template v-if="isFromEasyPage">
            <fieldset :class="isHostValueInvalid ? ' error-border' : ''">
              <legend style="z-index: 5;">{{ $t('host') }}</legend>
              <b-input
                class="modal-input right"
                :placeholder="hostValuePlaceholder"
                @input.native="validateHostValue"
                v-model="hostValue"
                :disabled="isHostTypeAny"
                tabindex="2"
              />
              <p v-if="isHostTypeHostname" v-html="$t('hostnameInfo')" />
            </fieldset>
          </template>
          <template v-else>
            <fieldset :class="isHostTypeAny ? 'typeahead-fieldset' : ''">
              <legend style="z-index: 5;">{{ $t('host') }}</legend>
              <typeahead
                class="modal-input right dropdown"
                :placeholder="hostValuePlaceholder"
                v-model="hostValue"
                :data="dropdownData"
                ref="typeahead"
                @input="handleHostValueChange"
              />
              <p v-if="isHostTypeHostname" v-html="$t('hostnameInfo')" />
              <div v-if="isHostTypeAny" class="disable-typeahead" />
            </fieldset>
          </template>
        </div>
      </b-row>
      <b-row>
        <div class="col-12" v-if="isAllocateCountInvalid">
          <p :class="`invalid-host-value-text ${topMarginClass}`">
            {{ invalidAllocateCount }}
          </p>
        </div>
        <div class="col-12" v-if="isHostValueInvalid">
          <p :class="`invalid-host-value-text ${topMarginClass}`">
            {{ $t('invalidHostTypeMessage', { hostType: readableHostType }) }}
          </p>
        </div>
      </b-row>
      <b-row class="buttons-container text-center">
        <div class="col-12">
          <b-button
            class="cta-btn"
            variant="primary"
            size="lg"
            :disabled="isStepOneCtaButtonDisabled"
            @click="currentStep = 2"
            :tabindex="isHostTypeAny ? 2 : 3"
          >
            {{ $t('createLicenseFile') }}
          </b-button>
        </div>
        <div class="col-12">
          <a href="#" class="danger-text" v-b-modal="modalName" @click.stop.prevent="resetModalAndClose">
            {{ $t('cancel') }}
          </a>
        </div>
      </b-row>
    </b-container>
    <b-container fluid class="step text-center" v-else-if="currentStep === 2">
      <b-row>
        <div class="col-12">
          <h5>{{ $t('allocateConfirmation') }}</h5>
          <h6 v-html="allocateConfirmationInfo" />
        </div>
      </b-row>
      <b-row class="buttons-container">
        <div class="col-12">
          <b-button
            class="cta-btn"
            variant="success"
            size="lg"
            @click="createLicenseFile"
          >
            {{ $t('allocateConfirmationYes') }}
          </b-button>
        </div>
        <div class="col-12">
          <a href="#" class="danger-text" @click.stop.prevent="goToStepOne">
            {{ $t('allocateConfirmationNo') }}
          </a>
        </div>
      </b-row>
    </b-container>
    <b-container fluid class="step text-center" v-else-if="currentStep === 3">
      <b-row>
        <div class="col-12">
          <h5>{{ $t('allocateConfirmationLoadingHeader') }}</h5>
          <h6>{{ $t('allocateConfirmationLoadingInfo') }}</h6>
        </div>
      </b-row>
      <b-row>
        <div class="col-12">
          <loading customStyle="padding: 10px;" />
        </div>
      </b-row>
    </b-container>
    <b-container fluid class="step text-center" v-else-if="currentStep === 4">
      <b-row>
        <div class="col-12">
          <h5 class="success-text">{{ $t('allocateDownload') }}</h5>
          <h6 v-html="$t('allocateDownloadInfo', { hostValue })" />
        </div>
      </b-row>
      <b-row class="buttons-container">
        <div class="col-12">
          <!-- This is just a mock to show download. -->
          <b-button
            variant="primary"
            class="cta-btn"
            @click="downloadLicenseFiles"
            :disabled="isDownloading"
          >
            {{ $tc('downloadLicenseFiles', 1) }}
            <i v-if="isDownloading" class="fa fa-spinner loading-animation" />
          </b-button>
        </div>
        <div class="col-12" v-if="!isFull && remainingCount > 0">
          <a href="#" class="primary-text" @click.stop.prevent="currentStep = 1; hostValue = ''">
            {{ $t('allocateMoreLicenses') }}
          </a>
        </div>
      </b-row>
    </b-container>
    <b-container fluid class="step" v-else>
      <b-row>
        <div class="col-12">
          <h6 v-html="errorDescription" />
        </div>
      </b-row>
      <b-row v-if="errorType === 'data'" class="buttons-container text-center">
        <div class="col-12">
          <b-button
            class="cta-btn"
            variant="primary"
            size="lg"
            @click="downloadLicenseFiles"
            :disabled="isDownloading"
          >
            {{ $t('allocateFailCtaButtonText') }}
            <i v-if="isDownloading" class="fa fa-spinner loading-animation" />
          </b-button>
        </div>
        <div class="col-12">
          <b-button
            class="secondary-btn"
            variant="primary"
            size="lg"
            @click="downloadFailedTextFile"
          >
            {{ $t('allocateFailSecondaryButtonText') }}
          </b-button>
        </div>
      </b-row>
    </b-container>
    <div slot="modal-footer" />
    </b-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapGetters, mapMutations } from 'vuex'
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
  import download from 'downloadjs'
  import SurveyModal from './SurveyModal'
  import Loading from './Loading'

  export default {
    name: 'AllocationModal',
    components: {
      'loading': Loading,
      'typeahead': VueBootstrapTypeahead,
      'survey-modal': SurveyModal
    },
    props: {
      modal: { type: Boolean, required: true },
      closeModal: { type: Function, required: true },
      openModal: { type: Function, required: true },
      selectedLicenses: { type: Array, required: true },
      isFromEasyPage: { type: Boolean, default: false },
      getUpdatedLicenses: { type: Function, required: true },
      customHeader: { type: String, default: '' }
    },
    data () {
      return {
        hostValue: '',
        totalRemainingCount: 0,
        remainingCount: 0,
        currentStep: 1,
        isHostValueInvalid: false,
        isFetchingDropdown: false,
        dropdownData: [],
        allowPartial: false,
        errorType: '',
        failedAllocations: [],
        succeededAllocations: [],
        wasDataFetched: false,
        isAllocateCountInvalid: false,
        isDownloading: false,
        modalName: 'survey-license-modal',
        showSurveyModalProp: true
        // showModal: false
        // (this.selectedLicenses.some(item => item.ProductName.includes('XenServer')) && (this.$store.getters.xsSurveyUrl))
      }
    },
    created () {
      console.log('test', 'test')
      console.log('In Alloc modal selectedLic', this.selectedLicenses)
      Vue.AppInsights.trackPageView('Allocation page', '/allocation')
    },
    updated () {
      if (this.modal && !this.wasDataFetched) {
        const remainingCount = this.selectedLicenses.reduce((a, c) => {
          a = a + c.RemainingUserCount
          return a
        }, 0)
        this.remainingCount = remainingCount
        this.totalRemainingCount = remainingCount
        this.isFetchingDropdown = true
        if (this.selectedLicenses.length === 1) {
          const { ActivationID, SerialNumber } = this.selectedLicenses[0]
          if (!this.isAllowPartialForWebKey) {
            this.bottle.get(
              this.UrlBuilder.getAllowPartialUrl(
                ActivationID, this.customerId, SerialNumber, this.isFromEasyPage
              ),
              {
                headers: {
                  ...this.easyHeader
                }
              }
            )
              .then(({ data }) => {
                this.allowPartial = data === 'true' || data === true
              })
              .catch((error) => {
                this.loggly.log({
                  errorMessage: 'Failed to fetch get allow partial parameter for license',
                  errorObject: error,
                  errorStack: error.stack
                })
              })
          } else {
            this.allowPartial = this.isAllowPartialForWebKey
          }
        }
        if (!this.isFromEasyPage) {
          this.bottle.get(this.UrlBuilder.getAllocateDropdownUrl(
            this.activationID,
            this.customerId
          ))
            .then(({ data }) => {
              this.dropdownData = data || []
              this.isFetchingDropdown = false
            })
            .catch((error) => {
              this.isFetchingDropdown = false
              this.loggly.log({
                errorMessage: 'Failed to fetch Host IDs for dropdown',
                errorObject: error,
                errorStack: error.stack
              })
            })
        }
        this.wasDataFetched = true
      }
      if (this.isHostTypeAny) {
        this.hostValue = 'Any'
        if (this.$refs.typeahead) {
          this.$refs.typeahead.inputValue = 'Any'
        }
      }
    },
    computed: {
      ...mapGetters(['isAllowPartialForWebKey', 'validXSSurveyData', 'isSurveyModalInteracted', 'isSurveyModalInteractedXS', 'showSurveyModal', 'showSurveyModalXS', 'validSurveyURL', 'validXSSurveyData']),
      remainingCountState () {
        if (this.remainingCount > this.totalRemainingCount) return false
        if (this.isAllocateCountInvalid) return false
        return null
      },
      // isXSSurvey () {
      //   console.log('Selected inside isXSSurvey', this.selectedLicenses)
      //   console.log('this.$store.getters.xsSurveyUrl', this.$store.getteßrs.xsSurveyUrl)
      //   if (this.$store.getters.xsSurveyUrl) {
      //     console.log('isSXSurvey method', this.validXSSurveyData.Url)
      //   }
      //   return (this.selectedLicenses.some(item => item.ProductName.includes('XenServer')) && (this.$store.getters.xsSurveyUrl))
      // },
      isFull () {
        if (this.isAllowPartialForWebKey) return false
        if (!this.allowPartial) return true
        return this.selectedLicenses.length > 1
      },
      activationID () {
        if (this.selectedLicenses.length > 0) {
          console.log('Selected inside activationID', this.selectedLicenses)
          return this.selectedLicenses[0].ActivationID
        }
        return ''
      },
      hostType () {
        if (this.selectedLicenses.length > 0) {
          return this.selectedLicenses[0].HostType
        }
        return ''
      },
      readableHostType () {
        switch (this.hostType) {
          case 'Ethernet':
            return this.$t('macAddress')
          case 'Internet':
            return this.$t('ipAddress')
          case 'HostName':
            return this.$t('hostname')
        }
      },
      isHostTypeAny () {
        return this.hostType.toLowerCase() === 'any'
      },
      isHostTypeHostname () {
        return this.hostType.toLowerCase() === 'hostname'
      },
      hostValuePlaceholder () {
        switch (this.hostType) {
          case 'Ethernet':
            return this.$t('enterMacAddress')
          case 'Internet':
            return this.$t('enterIpAddress')
          case 'HostName':
            return this.$t('enterHostName')
          case 'Any':
            return this.$t('any')
          default:
            return ''
        }
      },
      isHostValueValid () {
        let regEx
        let isValid = false
        switch (this.hostType) {
          case 'Ethernet':
            regEx = /^[0-9a-fA-F]{12}$/
            break
          case 'Internet':
            regEx = /\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/
            break
          case 'HostName':
            regEx = /^[^~{}[\]<>\s]+$/ // exclude characters ~{}[]<>
            break
          case 'Any':
            // match ethernet or internet or any
            regEx = /(^[0-9a-fA-F]{12}$|\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b|^\S*$)/
            break
          default:
            return false
        }
        isValid = regEx.test(this.hostValue)
        if (isValid) {
          return !this.$store.getters.hasXssKeyWord(this.hostValue)
        }
        return false
      },
      isStepOneCtaButtonDisabled () {
        return this.hostValue === '' ||
          !this.isHostValueValid ||
          this.isAllocateCountInvalid ||
          this.remainingCount > this.totalRemainingCount
      },
      customerId () {
        return this.$store.getters.person.customerId
      },
      loggedInUserName () {
        return this.$store.getters.authToken.userName || ''
      },
      loggedInUserPersonID () {
        return this.$store.getters.authToken.personId || ''
      },
      topMarginClass () {
        return this.isHostTypeHostname ? 'message top-margin' : ''
      },
      allocateTitle () {
        switch (this.errorType) {
          case 'data':
            return this.$t('failDataErrorTitle')
          case 'system':
            return this.$t('failSystemErrorTitle')
          default:
            return this.$t('allocateLicenses')
        }
      },
      errorDescription () {
        switch (this.errorType) {
          case 'data':
            return this.$t('failDataErrorDescription', {
              customerServiceUrl: this.UrlBuilder.customerServiceUrl
            })
          case 'system':
            return this.$t('failSystemErrorDescription', {
              customerServiceUrl: this.UrlBuilder.customerServiceUrl
            })
          default:
            return ''
        }
      },
      failedDownloadText () {
        return `${this.$t('referCustomerCare')}\r\n\r\n` +
          `${this.$t('unableToAllocatePrefix')}\r\n\r\n` +
          `${this.failedAllocations.join('\r\n')}\r\n\r\n` +
          `${this.$t('unableToAllocateSuffix')}\r\n\r\n` +
          `${this.$t('contactCitrix')}`
      },
      allocateConfirmationInfo () {
        return this.$t('allocateConfirmationInfo', {
          remainingCount: this.remainingCount,
          hostValue: this.hostValue,
          license: this.remainingCount === 1 ? this.$t('license') : this.$tc('licenses', 2)
        })
      },
      easyHeader () {
        if (!this.isFromEasyPage) return {}
        return {
          'X-Easyheader': this.customHeader
        }
      },
      invalidAllocateCount () {
        if (isNaN(Number(this.remainingCount))) {
          return this.$t('invalidAllocateCountNonNumeric')
        } else if (Number(this.remainingCount) > Number(this.totalRemainingCount)) {
          return this.$t('invalidAllocateCountExcessCount', { count: this.totalRemainingCount })
        }
        return this.$t('invalidAllocateCount')
      }
    },
    methods: {
      ...mapMutations([
        'SHOW_SURVEY_MODAL',
        'SHOW_SURVEY_MODAL_XS',
        'SURVEY_MODAL_CLOSED',
        'SURVEY_MODAL_CLOSED_XS'
      ]),
      handleAllocateCountBlur () {
        const count = Number(this.remainingCount)
        this.isAllocateCountInvalid = count === 0 ||
          isNaN(count) ||
          count > Number(this.totalRemainingCount)
      },
      createLicenseFile () {
        this.currentStep = 3
        if (this.totalRemainingCount >= this.remainingCount) {
          this.bottle
            .post(this.UrlBuilder.getAllocateUrl(this.isFromEasyPage), {
              customerId: this.customerId,
              fulfillmentsList: this.selectedLicenses.map(l => ({
                activationID: l.ActivationID,
                hostValue: encodeURIComponent(this.hostValue),
                hostType: l.HostType,
                quantity: this.isFull ? l.RemainingUserCount : this.remainingCount,
                orderId: l.OrderID,
                serialNumber: l.SerialNumber,
                licenseLineItemNumber: l.LicenseItemNumber,
                productName: l.ProductName,
                assetID: l.AssetID
              })),
              loggedInUserName: this.loggedInUserName,
              loggedInUserPersonID: this.$store.getters.person.id,
              action: 'Allocate'
            }, {
              headers: { ...this.easyHeader }
            })
            .then(({ data }) => {
              this.totalRemainingCount = this.totalRemainingCount - this.remainingCount
              this.remainingCount = this.totalRemainingCount
              Vue.AppInsights.trackEvent('Allocation action', {
                customerId: this.customerId,
                data: data.map(d => ({
                  hostType: d.hostIDType,
                  hostId: d.hostIDValue,
                  quantity: d.quantity,
                  status: d.status,
                  remainingQuantity: d.remainingQuantity
                }))
              })
              if (data.some(d => d.status === 'FAILURE')) {
                const failedAllocations = data
                  .filter(d => d.status === 'FAILURE')
                  .map(d => d.activationID)
                this.selectedLicenses.forEach((l) => {
                  let arr
                  if (failedAllocations.includes(l.ActivationID)) {
                    arr = [...this.failedAllocations]
                    arr.push(l)
                    this.failedAllocations = arr.map(l => l.ActivationID)
                  } else {
                    arr = [...this.succeededAllocations]
                    arr.push(l)
                    this.succeededAllocations = arr
                  }
                })
                this.currentStep = 5
                this.errorType = 'data'
              } else {
                this.currentStep = 4
                this.succeededAllocations = [...this.selectedLicenses]
              }
            })
            .catch((error) => {
              this.currentStep = 5
              this.errorType = 'system'
              this.loggly.log({
                errorMessage: 'Failed to allocate licenses',
                errorObject: error,
                errorStack: error.stack
              })
            })
        } else {
          this.remainingCount = 0
        }
      },
      downloadLicenseFiles () {
        this.isDownloading = true
        this.bottle
          .post(
            this.UrlBuilder.getDownloadUrl(this.isFromEasyPage),
            this.succeededAllocations.map((l) => ({
              activationID: l.ActivationID,
              customerId: this.customerId,
              hostId: [this.hostType === 'Ethernet' ? `Ethernet=${this.hostValue}` : this.hostValue],
              hostType: this.hostType,
              loggedInUserName: this.loggedInUserName,
              loggedInUserPersonID: this.$store.getters.person.id,
              action: 'Allocate Download',
              licenseLineItemNumber: l.LicenseItemNumber,
              productName: l.ProductName,
              assetID: l.AssetID
            })), {
              responseType: 'arraybuffer',
              headers: {
                ...this.easyHeader
              }
            }
          )
            .then(({ data, headers }) => {
              const fileName = this.getDownloadFilename(headers['content-disposition'])
              Vue.AppInsights.trackEvent('Download action', {
                customerId: this.customerId,
                data: this.succeededAllocations.map((l) => ({
                  activationID: l.ActivationID,
                  customerId: this.customerId,
                  hostId: [this.hostType === 'Ethernet' ? `Ethernet=${this.hostValue}` : this.hostValue],
                  hostType: this.hostType,
                  loggedInUserName: this.loggedInUserName,
                  loggedInUserPersonID: this.$store.getters.person.id,
                  action: 'Allocate Download',
                  licenseLineItemNumber: l.LicenseItemNumber,
                  productName: l.ProductName,
                  assetID: l.AssetID
                }))
              })
              this.isDownloading = false
              switch (headers['content-type']) {
                case 'application/zip':
                  const link = document.createElement('a')
                  link.href = window.URL.createObjectURL(
                    new Blob([data], { type: 'application/zip' })
                  )
                  link.download = fileName
                  link.click()
                  break
                case 'text/html':
                  download(data, fileName, 'text/html')
              }
            })
            .catch((error) => {
              this.isDownloading = false
              this.loggly.log({
                errorMessage: 'License download failed',
                errorObject: error,
                errorStack: error.stack
              })
            })
      },
      validateHostValue () {
        this.isHostValueInvalid = !this.isHostValueValid
      },
      handleHostValueChange (hostValue) {
        this.isHostValueInvalid = !this.isHostValueValid
        this.$refs.typeahead.inputValue = hostValue.slice(0, 1000)
      },
      downloadFailedTextFile () {
        download(this.failedDownloadText, 'failed-licenses.txt', 'text/html')
      },
      closeSurveyModal (isXenServer) {
        console.log('close survey model start')
        if (isXenServer) {
          this.openModal()
        } else {
          this.showSurveyModalProp = false
        }
        console.log('close survey model end')
      },
      resetModalAndClose () {
        console.log(this.selectedLicenses)
        if (this.selectedLicenses.length > 0) {
          if (this.selectedLicenses.some(item => item.ProductName.includes('XenServer'))) {
            this.showSurveyModalProp = false
            this.SURVEY_MODAL_CLOSED_XS(true)
            this.SHOW_SURVEY_MODAL_XS(false)
            this.SHOW_SURVEY_MODAL(false)
          } else {
            if (!this.isSurveyModalInteracted && this.validSurveyURL) {
              this.showSurveyModalProp = true
              this.SHOW_SURVEY_MODAL(true)
              this.SHOW_SURVEY_MODAL_XS(false)
            } else {
              this.showSurveyModalProp = false
              this.SHOW_SURVEY_MODAL(false)
              this.SHOW_SURVEY_MODAL_XS(false)
            }
          }
        }
        this.hostValue = ''
        this.totalRemainingCount = 0
        this.remainingCount = 0
        this.currentStep = 1
        this.isHostValueInvalid = false
        this.isFetchingDropdown = false
        this.dropdownData = []
        this.allowPartial = false
        this.errorType = ''
        this.failedAllocations = []
        this.succeededAllocations = []
        this.wasDataFetched = false
        this.isAllocateCountInvalid = false
        this.isDownloading = false
        this.closeModal()
        this.getUpdatedLicenses()
        this.clearTypeahead()
      },
      getDownloadFilename (string) {
        return string.split('; ')[1].split('=')[1]
      },
      clearTypeahead () {
        if (this.$refs.typeahead) {
          this.$refs.typeahead.inputValue = ''
        }
      },
      goToStepOne () {
        this.currentStep = 1
        this.$nextTick(() => {
          if (this.$refs.typeahead) {
            this.$refs.typeahead.value = this.hostValue
            this.$refs.typeahead.inputValue = this.hostValue
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';

  button:focus {
    box-shadow: none !important;
    border: none;
    outline: 0;
  }

  a {
    text-decoration: none !important;
  }

  .primary-text {
    color: $primary;
  }

  .success-text {
    color: $success;
  }

  .danger-text {
    color: $danger;
  }

  .modal-input {
    display: inline-block;
    height: 48px;
    width: 80px;
    max-width: 80px;
    margin-top: 12px;
  }

  fieldset {
    border: 1px solid $lightGray;
    height: 60px;
    border-radius: 5px;
    padding: 10px 0 0;
    width: 100%;
    position: relative;
  }

  fieldset > legend {
    padding: 0 10px;
    margin-left: 10px;
    width: auto;
    font-size: 14px;
    color: $darkGray;
    margin-bottom: 0;
    z-index: $legendZIndex;
    position: relative;
    background-color: white;
  }

  .form-control:disabled, .form-control[readonly] {
    background-color: white;
    cursor: not-allowed;
  }

  .modal-input.right {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    border: none !important;
    position: relative;
    top: -20px;
    margin-top: 0;
  }

  .buttons-container {
    margin-top: 20px;
  }

  .cta-btn,
  .secondary-btn {
    display: inline-block;
    border-radius: 25px;
    margin-bottom: 20px;
  }

  .secondary-btn {
    background-color: transparent !important;
    color: $primary;
    border: 1px solid $primary;
  }

  .secondary-btn:hover {
    background-color: transparent !important;
    color: $primaryHover;
    border-color: $primaryHover;
  }

  .step h5 {
    font-size: 26px;
    font-weight: 400;
  }

  .step h6 {
    font-size: 18px;
    font-weight: 400;
  }

  .error-border {
    border-color: $danger;
  }

  .invalid-host-value-text {
    color: $danger;
    padding: 10px 0 0;
    margin: 0;
    font-size: 14px;
  }

  .disable-typeahead {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .disable-typeahead:hover {
    cursor: not-allowed;
  }

  .full-allocation-message {
    color: $darkGray;
    font-size: 16px;
    font-weight: normal;
  }
  .inputs-row {
    padding-bottom: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AllocationModal.vue